import { render, staticRenderFns } from "./FooterPerfilStore.vue?vue&type=template&id=49b4544b"
import script from "./FooterPerfilStore.vue?vue&type=script&lang=js"
export * from "./FooterPerfilStore.vue?vue&type=script&lang=js"
import style0 from "./FooterPerfilStore.vue?vue&type=style&index=0&id=49b4544b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports